import Vue from 'vue';
import {mapGetters} from 'vuex'
const mixin = {
  data () {
    return {
      $_loading: false,
      $_loadingObj: null
    }
  },
  methods: {
    $_hideLoading () {
      if (this.$_loading) {
        this.$_loadingObj.close()
        this.$_loading = false
      }
    },
    $_showLoading (options = {}) {
      if (!this.$_loading) {
        this.$_loadingObj = this.$loading({
          lock: true,
          text: options.text || 'Loading',
          target: options.target || 'document.body',
          spinner: 'el-icon-loading',
          fullscreen: options.target ? false : true,
          background: options.background || 'rgba(0, 0, 0, 0.3)'
        })
        this.$_loading = true
      }
    },
    /**
     * 设置顶部title方法，
     * */
    $_setTitle(value) {
      value = value || '宁夏教育资源公共服务平台';
      document.title = value;
    }
  },
}
Vue.mixin(mixin);


/*
* 定义非全局需要公用插入组件的方法，
* */
const themeMixin = {
  computed: {
    ...mapGetters([
      'theme'
    ])
  },
  watch: {
    theme() {
      // 针对于主题切换，需要改变色彩的第三放插件处理，如地图等。
    }
  }
}

export {themeMixin}